var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5319 10.0422L9.47188 15.1022C8.82188 14.4522 8.42188 13.5622 8.42188 12.5722C8.42188 10.5922 10.0219 8.99219 12.0019 8.99219C12.9919 8.99219 13.8819 9.39219 14.5319 10.0422Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8198 6.33687C16.0698 5.01687 14.0698 4.29688 11.9998 4.29688C8.46984 4.29688 5.17984 6.37687 2.88984 9.97687C1.98984 11.3869 1.98984 13.7569 2.88984 15.1669C3.67984 16.4069 4.59984 17.4769 5.59984 18.3369",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42188 20.1C9.56187 20.58 10.7719 20.84 12.0019 20.84C15.5319 20.84 18.8219 18.76 21.1119 15.16C22.0119 13.75 22.0119 11.38 21.1119 9.97C20.7819 9.45 20.4219 8.96 20.0519 8.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5114 13.2734C15.2514 14.6834 14.1014 15.8334 12.6914 16.0934",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 15.1016L2 22.5716",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0013 2.57031L14.5312 10.0403",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.16e96906218c4dc97a080f0927895af9.svg";
export { ForwardRef as ReactComponent };